import { render, staticRenderFns } from "./TaskListUntreated.vue?vue&type=template&id=183807d4&"
import script from "./TaskListUntreated.vue?vue&type=script&lang=ts&"
export * from "./TaskListUntreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports